<ig-card class="place-card" [class.long-card-wrap]="customSettings?.calendarStyle?.place==='long'"
    [class.square-card-wrap]="customSettings?.calendarStyle?.place==='square'||customSettings?.calendarStyle?.place==='default'"
    [class.tile-card-wrap]="customSettings?.calendarStyle?.place==='tile'" [containTitle]="true"
    [isOperating]="isOperating" [placeCategoryList]="place.categoryList" [picture]="place.cover?.source">
    <div status>
        <div class="status-first">
            <div class="approved" *ngIf="place.isApproved">approved</div>
            <div class="unapproved" *ngIf="!place.isApproved">pending approval</div>
            <div class="closed" *ngIf="place.business_status?.includes('CLOSED')"
                matTooltip="{{'this place is ' + place.business_status.toLowerCase().replace('_',' ')}}">closed</div>
            <div class="pinned" *ngIf="place.pinnedTime">pinned</div>
            <div [ngClass]="{'pinned':!place.pinnedTime,'choice':!!place.pinnedTime}"
                *ngIf="customSettings&&!customSettings.isHideEditorChoice&&place.isChoice">
                {{editorChoiceText}}
            </div>
            <div class="pinned"
                [class.custom]="(place.pinnedTime&&!place.isChoice)||(!place.pinnedTime&&place.isChoice)"
                [class.custombottom]="place.pinnedTime&&place.isChoice" *ngIf="place.isCustom">in custom button
            </div>
            <div class="source">
                {{place.isManuallyCreated?'Manual':'Google'}}
            </div>
        </div>

        <div class="status-second">
            <div *ngIf="isItineraryOn&&isInTour()">In Itineraries</div>
            <div *ngIf="place.isToBeExport">PDF</div>
            <div *ngIf="place.isNotExistInSource" class="not-exist"
                matTooltip="Looks like this place no longer exists in Google">
                Not Exist</div>
            <div *ngIf="isInCustomBtn()">in custom btn</div>
            <div *ngIf="notAllowed" (click)="showEditCategoryModal()" style="background:#f5d005;width:160px"
                matTooltip="This place doesn't have any category that is allowed to show, please consider to update the category of this place, or update your custom place category settings"
                matTooltipClass="card-tooltip">
                pending custom category
                <mat-icon style="width:14px;height:14px;font-size:14px">edit</mat-icon>
            </div>
        </div>
    </div>

    <div actions>
        <ig-card-action *ngIf="!place.isApproved" icon="done" matTooltip="Approve" matTooltipClass="card-tooltip"
            matTooltipPosition="right" (click)="approve()">
            approve
        </ig-card-action>
        <ig-card-action *ngIf="place.isApproved" icon="clear" matTooltip="Unapprove" matTooltipClass="card-tooltip"
            matTooltipPosition="right" (click)="unApprove()">
            reject
        </ig-card-action>
        <ig-card-action *ngIf="!place.pinnedTime" icon="pin_drop" (click)="pin()" matTooltip="Pin to top"
            matTooltipClass="card-tooltip" matTooltipPosition="right">
            pin to top
        </ig-card-action>
        <ig-card-action *ngIf="place.pinnedTime" icon="pin_drop" (click)="unPin()" matTooltip="Unpin"
            matTooltipClass="card-tooltip" matTooltipPosition="right">
            unpin
        </ig-card-action>

        <ng-container *ngIf="customSettings&&!customSettings.isHideEditorChoice">
            <ig-card-action *ngIf="!place.isChoice" icon="favorite_border" (click)="choice()"
                [matTooltip]="addToEditorChoiceTextTip" matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
            <ig-card-action *ngIf="place.isChoice" icon="favorite" (click)="unChoice()"
                [matTooltip]="removeFromEditorChoiceTextTip" matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </ng-container>

        <!--<div (click)="place.isCustom ? unCustom() : custom();$event.stopPropagation()">-->
        <!--<ig-card-action *ngIf="!place.isCustom" icon="star"-->
        <!--matTooltip="Add to custom button"-->
        <!--matTooltipPosition="right">-->
        <!--</ig-card-action>-->
        <!--<ig-card-action *ngIf="place.isCustom" icon="star_border"-->
        <!--matTooltip="Remove from custom button"-->
        <!--matTooltipPosition="right">-->
        <!--</ig-card-action>-->
        <!--</div>-->
        <div (click)="place.isToBeExport ? unToBeExport() : toBeExport();$event.stopPropagation()">
            <ig-card-action *ngIf="!place.isToBeExport" icon="picture_as_pdf" matTooltip="Add to PDF export"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
            <ig-card-action *ngIf="place.isToBeExport" icon="picture_as_pdf" matTooltip="Remove from PDF export"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </div>
        <div (click)="showEditModal();$event.stopPropagation()">
            <ig-card-action icon="edit" matTooltip="Edit place" matTooltipClass="card-tooltip"
                matTooltipPosition="right">
            </ig-card-action>
        </div>
        <ig-card-action (click)="block()" icon="delete_forever"
            matTooltip="Move this place to your removed place list, places that are removed can be reverted as needed"
            matTooltipClass="card-tooltip" matTooltipPosition="right">
        </ig-card-action>
        <ig-drop-down
            [class.position-initial]="parent.customBtns&&parent.customBtns.places&&parent.customBtns.places.length>4"
            [class.lower-top]="parent.customBtns.places&&parent.customBtns.places.length>4&&parent.customBtns.places.length<9"
            showDropDownItem="true" class="long-btn">
            <ig-drop-down-trigger [useDiv]="true" class="add-to-tour" icon="star" matTooltip="Add to custom button"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-drop-down-trigger>
            <div items>
                <ng-container *ngFor="let btn of parent.customBtns.places;let i = index">
                    <ig-drop-down-item (click)="addOrRemoveToCustomBtn(btn, i)" matTooltip="{{btn.btnText}}">
                        <mat-icon class="red" *ngIf="isInCustomBtn(btn)">remove</mat-icon>
                        <mat-icon *ngIf="!isInCustomBtn(btn)">add</mat-icon>
                        {{btn.btnText}}
                    </ig-drop-down-item>
                </ng-container>


                <ig-drop-down-item *ngIf="!parent.customBtns.places||!parent.customBtns.places.length"
                    (click)="showMarketing()" matTooltip="Go to add a custom button" matTooltipClass="card-tooltip">(no
                    custom buttons available, create one)
                </ig-drop-down-item>
            </div>
        </ig-drop-down>

        <ig-drop-down *ngIf="place.isApproved&&isItineraryOn"
            [class.position-initial]="parent.tours&&parent.tours.length>4"
            [class.lower-top]="parent.tours&&parent.tours.length>4&&parent.tours.length<9" showDropDownItem="true"
            class="long-btn">
            <ig-drop-down-trigger [useDiv]="true" class="add-to-tour" icon="directions_car"
                matTooltip="Add to itineraries" matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-drop-down-trigger>
            <div items>
                <ig-drop-down-item *ngFor="let tour of parent.tours" (click)="addOrRemoveFromTour(tour)"
                    matTooltip="{{!isInTour(tour)?'Add to':'Remove from'}} {{tour.title}}">
                    <mat-icon class="red" *ngIf="isInTour(tour)">remove</mat-icon>
                    <mat-icon *ngIf="!isInTour(tour)">add</mat-icon>
                    {{tour.title}}
                </ig-drop-down-item>

                <ig-drop-down-item *ngIf="!parent.tours.length" (click)="gotoTours()"
                    matTooltip="Go to add an itinerary" matTooltipClass="card-tooltip">(no itineraries available, create
                    one)
                </ig-drop-down-item>
            </div>
        </ig-drop-down>
    </div>

    <div title>
        <span (click)="updateImage()">@</span>
        <!-- <span (click)="gotoWebsite()" [class.not-allowed]="notAllowed" -->
        <span (click)="gotoWebsite()" matTooltipClass="card-tooltip"
            [matTooltip]="notAllowed?'This place doesn\'t have any category that is allowed to show, please consider to update the category of this place, or update your custom place category settings':''">
            <span *ngIf="isSearchName" [innerHTML]="place.title| highlight:keyword"></span>
            <span *ngIf="!isSearchName">{{place.title}}</span>
            <mat-icon *ngIf="notAllowed" style="color: #eee">info</mat-icon>
        </span>
    </div>

    <div detail>
        <div class="detail" (click)="showId()">
            <mat-icon>pin_drop</mat-icon>            
            <span *ngIf="isSearchAddress" [innerHTML]="(place.address?.address || '(no location)')| highlight:keyword"></span>
            <span *ngIf="!isSearchAddress">{{place.address?.address || '(no location)'}}</span>
        </div>
        <div class="detail" *ngIf="place.socialName==='facebook'">
            <span><mat-icon>thumb_up</mat-icon>
                {{place.likes}} Likes / {{place.checkins}} Checkins</span>
        </div>
        <div class="detail" *ngIf="place.socialName==='google'">
            <span><mat-icon>thumb_up</mat-icon>Rating: {{place.rating}}
                / User Ratings Total: {{place.user_ratings_total}}</span>
        </div>
        <div class="detail">
            <mat-icon>list</mat-icon>  
            <span *ngIf="isSearchCategory" [innerHTML]="showReadable(place.category)| highlight:keyword"></span>
            <span *ngIf="!isSearchCategory">{{showReadable(place.category)}}</span>             
        </div>
    </div>
</ig-card>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/calendar/place.card/hub.place.card.component.html